export const API_ENDPOINTS = {
  // Authentication
  AUTH: {
    LOGIN: '/login',
    REGISTER: '/auth/register',
    LOGOUT: '/logout',
    REFRESH_TOKEN: '/token/refresh',
    ME: '/auth/me',
  },
  // Users
  USERS: {
    BASE: '/users',
    BY_ID: (id: string) => `/users/${id}`,
    PROFILE: '/users/profile',
  },
  // Products (example)
  PRODUCTS: {
    BASE: '/products',
    BY_ID: (id: string) => `/products/${id}`,
    CATEGORIES: '/products/categories',
  },
  // Search
  SEARCH: {
    BASE: '/search',
  },
} as const;
